define('AwaLabs.FacetsExtraConfig', [
    'Facets.Translator',
    'SC.Configuration',
    'underscore'
], function FacetsExtraConfig(
    FacetsTranslator,
    Configuration,
    _
) {
    'use strict';

    function addToSearchAPIMasterOptions(apiOptions) {
        var facetExclude = Configuration.get('facetsExtra.exclude') || [];
        var masterFacets = Configuration.get('facetsExtra.masterFacets') || [];

        _.each(apiOptions, function eachApiOptions(value) {
            _.each(masterFacets, function eachMasterFacet(masterFacet) {
                value[masterFacet.id] = masterFacet.value;
            });

            value['facet.exclude'] = value['facet.exclude'] ? value['facet.exclude'] + ',' + facetExclude.join(',') :
                facetExclude.join(',');
        });

        return apiOptions;
    }

    return {
        mountToApp: function mountToApp() {
            Configuration.searchApiMasterOptions = addToSearchAPIMasterOptions(
                Configuration.searchApiMasterOptions
            );
        }
    };
});
